import React from "react";
import ClientAssignedAccountantCard from "./ClientAssignedAccountantCard";

export default function ClientAccountingTeamList({
  team,
  loading,
  profileAccessLimited,
  membershipAccessLimited,
}) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="text-base font-bold text-slate-900">
            Your Accounting Team
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            Active professionals assigned to your business.
          </p>
        </div>
        {!loading && team.length > 0 && (
          <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600">
            {team.length} {team.length === 1 ? "member" : "members"}
          </span>
        )}
      </div>

      {loading ? (
        <div className="mt-5 flex items-center gap-3" aria-live="polite">
          <span className="h-5 w-5 animate-spin rounded-full border-2 border-violet-100 border-t-violet-600" />
          <p className="text-sm text-slate-500">Loading assigned team…</p>
        </div>
      ) : team.length ? (
        <>
          <div className="mt-5 grid gap-3 md:grid-cols-2">
            {team.map((member) => (
              <ClientAssignedAccountantCard
                key={member.id}
                accountant={member}
              />
            ))}
          </div>
          {team.length > 1 && (
            <p className="mt-4 text-xs text-slate-500">
              Multiple team members are assigned. No primary accountant is designated.
            </p>
          )}
          {(profileAccessLimited || membershipAccessLimited) && (
            <p className="mt-3 rounded-xl bg-amber-50 p-3 text-xs leading-5 text-amber-800">
              Some team profile or membership details are restricted by current visibility permissions. Active assignments are still shown.
            </p>
          )}
        </>
      ) : (
        <div className="mt-5 rounded-xl border border-dashed border-slate-300 px-5 py-8 text-center">
          <h3 className="text-sm font-bold text-slate-800">
            Accounting Team Not Yet Assigned
          </h3>
          <p className="mt-2 text-sm leading-6 text-slate-500">
            Your accounting firm is connected, but no team member has been assigned to your business yet.
          </p>
        </div>
      )}
    </section>
  );
}